module.exports = __webpack_public_path__ + "media/images/flags/1x1/nic-234f342765dca995158327bade8b16d0.svg";